const css = document.createElement('link')
css.href =
  '//maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css'
css.rel = 'stylesheet'
css.type = 'text/css'
document.getElementsByTagName('head')[0].appendChild(css)
